import { render, staticRenderFns } from "./Ubigeo.vue?vue&type=template&id=4d4ebb54&scoped=true&"
import script from "./Ubigeo.vue?vue&type=script&lang=js&"
export * from "./Ubigeo.vue?vue&type=script&lang=js&"
import style0 from "./Ubigeo.vue?vue&type=style&index=0&id=4d4ebb54&lang=scss&scoped=true&"
import style1 from "./Ubigeo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ebb54",
  null
  
)

export default component.exports